var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.898,
    height: 24.5,
    viewBox: "0 0 19.898 24.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#e62424cc}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bin",
    transform: "translate(.003 .002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    d: "M222.972 154.7a.574.574 0 0 0-.574.574v10.844a.574.574 0 1 0 1.148 0v-10.841a.574.574 0 0 0-.574-.577zm0 0",
    className: "cls-1",
    "data-name": "Path 695",
    transform: "translate(-209.641 -145.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    d: "M104.972 154.7a.574.574 0 0 0-.574.574v10.844a.574.574 0 1 0 1.148 0v-10.841a.574.574 0 0 0-.574-.577zm0 0",
    className: "cls-1",
    "data-name": "Path 696",
    transform: "translate(-98.411 -145.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    d: "M1.626 7.292v14.137a3.166 3.166 0 0 0 .842 2.183 2.826 2.826 0 0 0 2.05.886h10.856a2.825 2.825 0 0 0 2.05-.886 3.166 3.166 0 0 0 .842-2.183V7.292a2.192 2.192 0 0 0-.562-4.31h-2.938v-.717A2.254 2.254 0 0 0 12.493 0H7.4a2.254 2.254 0 0 0-2.274 2.265v.717H2.189a2.192 2.192 0 0 0-.562 4.31zm13.748 16.059H4.518a1.817 1.817 0 0 1-1.744-1.922V7.343h14.344v14.086a1.817 1.817 0 0 1-1.744 1.922zm-9.1-21.086A1.105 1.105 0 0 1 7.4 1.146h5.095a1.105 1.105 0 0 1 1.125 1.119v.717H6.274zM2.189 4.13H17.7a1.033 1.033 0 0 1 0 2.066H2.189a1.033 1.033 0 0 1 0-2.066zm0 0",
    className: "cls-1",
    "data-name": "Path 697"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    d: "M163.972 154.7a.574.574 0 0 0-.574.574v10.844a.574.574 0 1 0 1.148 0v-10.841a.574.574 0 0 0-.574-.577zm0 0",
    className: "cls-1",
    "data-name": "Path 698",
    transform: "translate(-154.026 -145.828)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.b4328ddf04c21cd8226b22db87cfdea0.svg";
export { ForwardRef as ReactComponent };